import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  trackPaywallCtaClicked,
  trackPaywallHit,
} from '@src/services/moengage';

// Fills package_code from redux; `open` fires the hit when a dialog opens, so one call covers every opener.
const usePaywallTracking = ({
  paywallType,
  module,
  product,
  surface,
  trigger,
  featureKey,
  voiceCode,
  open,
} = {}) => {
  const packageCode = useSelector((state) => state.user.usingPackage?.code);

  const trackHit = (type = paywallType, extra = {}) =>
    trackPaywallHit({
      paywallType: type,
      module,
      product,
      surface,
      trigger,
      featureKey,
      packageCode,
      voiceCode,
      ...extra,
    });

  const trackCta = (cta, extra = {}) =>
    trackPaywallCtaClicked({
      paywallType,
      cta,
      packageCode,
      surface,
      featureKey,
      product,
      voiceCode,
      ...extra,
    });

  useEffect(() => {
    if (open) trackHit();
  }, [open]);

  return { trackHit, trackCta };
};

export default usePaywallTracking;
